export const isDev = () => {
  return import.meta.env?.MODE === "development";
};

export const isStaging = () => {
  return window.origin.includes("staging");
};

export const isProd = () => {
  return !isDev() && !isStaging();
};

export const getEnv = () => {
  if (isDev()) {
    return "development";
  } else if (isStaging()) {
    return "staging";
  } else {
    return "production";
  }
};
